import React from 'react';
import { motion } from 'framer-motion';

const SimpleParticle = () => {
  // ⬇ only 7 particles, each spawn in lower-half area
  const particles = Array.from({ length: 7 }, (_, i) => ({
    id: i,
    x: Math.random() * 100,          // full width
    y: 55 + Math.random() * 45,      // only bottom 45% (55–100%)
    delay: Math.random() * 2,
    duration: 3 + Math.random() * 4,
    blur: Math.random() > 0.7 ? 2 : 0.7,
    size: 2 + Math.random() * 3      // 2–5px particles (smaller = cleaner)
  }));

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {particles.map((p) => (
        <motion.div
          key={p.id}
          className="absolute bg-white rounded-full opacity-60"
          style={{
            width: p.size,
            height: p.size,
            left: `${p.x}%`,
            top: `${p.y}%`,
            filter: `blur(${p.blur}px)`
          }}
          animate={{
            y: [0, -15, 0],
            x: [0, Math.random() * 8 - 4, 0],
            opacity: [0.3, 0.8, 0.3]
          }}
          transition={{
            duration: p.duration,
            delay: p.delay,
            repeat: Infinity,
            ease: 'easeInOut'
          }}
        />
      ))}
    </div>
  );
};

export default SimpleParticle;
